import KbDocuments from '@/components/knowledgeBase/KbDocuments';
import KbWebsiteUrls from '@/components/knowledgeBase/KbWebsiteUrls';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const KnowledgeBasePage = () => {
  return (
    <main className="px-4 py-6 max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Knowledge Base</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage the sources the assistant answers from. Content is only picked
          up when a sync runs — trigger one after publishing website changes.
        </p>
      </div>

      <Tabs defaultValue="urls">
        <TabsList className="mb-4">
          <TabsTrigger value="urls">Website URLs</TabsTrigger>
          <TabsTrigger value="documents">Documents</TabsTrigger>
        </TabsList>

        <TabsContent value="urls">
          <KbWebsiteUrls />
        </TabsContent>

        <TabsContent value="documents">
          <KbDocuments />
        </TabsContent>
      </Tabs>
    </main>
  );
};

export default KnowledgeBasePage;
